import { useEffect, useRef } from 'react'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'

const FROM_GALLERY_PARAM = 'fromGallery'

// Promotes the cross-page "from gallery" signal into router state. The in-studio
// gallery sets location.state.fromGallery directly on navigate, but the /ai/landing
// gallery is a separate page: its card click can only carry origin as a query param
// (`?fromGallery=true`) across the full page load, since React Router's in-memory
// location.state does not survive one. On arrival this strips the param and replays
// it as location.state.fromGallery, so the in-studio reads (LeftSide CTA label,
// RemixModeNotice) stay on a single source of truth - location.state - regardless
// of which gallery the user came from. Pathname is untouched, so useModelUrlSync
// (which keys on pathname) does not refetch.
const useGalleryOriginSync = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const promotedRef = useRef(false)

  const search = location?.search ?? ''

  useEffect(() => {
    if (promotedRef.current) return

    const params = new URLSearchParams(search)
    if (params.get(FROM_GALLERY_PARAM) !== 'true') return

    promotedRef.current = true
    params.delete(FROM_GALLERY_PARAM)
    const nextSearch = params.toString()

    navigate(
      { pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : '' },
      { replace: true, state: { ...location.state, fromGallery: true } }
    )
  }, [search, location.pathname, location.state, navigate])
}

export default useGalleryOriginSync
